module.exports = __webpack_public_path__ + "assets/img/cdz.fa39d1b7.png";